module.exports = __webpack_public_path__ + "static/media/loading2.f2681dd4.gif";